import type { IconDef } from '../types';

export const playCircle: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M12 0C18.6218 0 24 5.37818 24 12C24 18.6218 18.6218 24 12 24C5.37818 24 0 18.6218 0 12C1.93648e-07 5.37818 5.37818 1.93642e-07 12 0ZM17.1816 3.66504C12.9271 1.0144 7.14522 2.59667 4.28711 7.2002C1.4291 11.8038 2.56388 17.695 6.81836 20.335C11.0729 22.9747 16.8548 21.3817 19.7129 16.7891V16.7998C22.5709 12.1962 21.4361 6.305 17.1816 3.66504ZM9.29492 6.67578C9.64396 6.49047 10.0691 6.5016 10.4072 6.71973L17.3457 11.1807C17.6621 11.377 17.8477 11.7267 17.8477 12.0977C17.8476 12.4684 17.6619 12.8173 17.3457 13.0137L10.4072 17.4756C10.2327 17.5956 10.0256 17.6504 9.81836 17.6504C9.63305 17.6504 9.45845 17.6067 9.29492 17.5195C8.9459 17.3232 8.72763 16.9631 8.72754 16.5596V7.63574C8.72754 7.23211 8.94583 6.86124 9.29492 6.67578ZM10.7998 14.4756L14.7383 12.1846L11.0186 9.55566L10.7998 14.4756Z',
    },
  ],
};
